import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';

import HelpTooltip from 'components/help-tooltip';

class FieldDefault extends PureComponent {
    constructor(props) {
        super(props);

        this.inputElement = null;

        this.state = {
            value: this.props.value || '',
            type: props.type,
            populated: (this.props.value || '') !== '',
            focus: false
        };
        this.handleFocus = this.handleFocus.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.togglePassword = this.togglePassword.bind(this);
    }

    handleChange = event => {
        const value = this.getValue();

        this.updateValue(value);

        this.props.onChange && this.props.onChange(this.props.triggerAsEvent ? event : value);
    }

    handleFocus() {
        this.setState({
            focus: true
        });

        this.props.onFocus && this.props.onFocus();
    }

    handleBlur() {
        this.setState({
            focus: false
        });

        if (!this.inputElement) {
            return;
        }

        this.props.onBlur && this.props.onBlur(this.inputElement.value);
    }

    handleKeyDown = event => {
        if (this.props.blurOnEnter && event.which === 13) {
            event.preventDefault();
            this.blur();
        }

        this.props.onKeyDown && this.props.onKeyDown(event);
    }

    updateValue(value) {
        this.setState({
            value: value,
            populated: value !== ''
        });
    }

    getValue() {
        const rawValue = this.inputElement.value;

        if (this.props.replacer) {
            return this.props.replacer(rawValue);
        }

        return rawValue;
    }

    togglePassword() {
        let newType = 'text';

        if (this.state.type === 'text') {
            newType = 'password';
        }

        this.setState({
            type: newType
        });
    }

    focus() {
        this.inputElement && this.inputElement.focus();
    }

    blur() {
        this.inputElement && this.inputElement.blur();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value && this.props.value !== this.state.value) {
            this.updateValue(this.props.value);
        }
    }

    componentDidMount() {
        const ctrl = {
            focus: () => {
                this.focus();
            },
            getValue: () => {
                return this.state.value;
            },
            setValue: value => {
                this.setState({ value });
            },
            isPopulated: () => {
                return this.state.populated;
            }
        };

        if (this.props.provideController) {
            if ('current' in this.props.provideController) {
                this.props.provideController.current = ctrl;
            } else {
                this.props.provideController && this.props.provideController(ctrl);
            }
        }

        if (this.props.autoFocus) {
            this.focus();
        }
    }

    componentWillUnmount() {
        if (this.props.provideController) {
            if ('current' in this.props.provideController) {
                this.props.provideController.current = null;
            } else {
                this.props.provideController && this.props.provideController(null);
            }
        }
    }

    get label() {
        if (this.props.label) {
            return (
                <label htmlFor={this.props.id} className={'field-label' + (this.props.darkLabel ? ' dark' : '') + (this.props.largeLabel ? ' large' : '')}>
                    {this.props.label}

                    {this.props.required ? <span className="req"> *</span> : null}

                    { this.props.labelHelp ? <HelpTooltip>{this.props.labelHelp}</HelpTooltip> : null }
                </label>
            );
        } else {
            return null;
        }
    }

    render() {
        const { t } = this.props;

        return (
            <div className="field-holder">
                {this.label}

                <div className={'field field-default' + (this.props.disabled ? ' disabled' : '') + (this.state.populated ? ' populated' : '') + (this.state.focus ? ' focus' : '') + (this.props.shortField ? ' field-short' : '') + (this.props.error ? ' error' : '') + (this.props.small ? ' field-small' : '') + (this.props.large ? ' field-large' : '')} onClick={this.props.onClick}>

                    {this.props.children}

                    <input
                        className="field-input"
                        ref={inputElement => this.inputElement = inputElement}
                        type={this.state.type || 'text'}
                        readOnly={this.props.readonly}
                        name={this.props.name}
                        value={this.state.value}
                        id={this.props.id}
                        placeholder={this.props.placeholder}
                        onKeyDown={this.handleKeyDown}
                        onInput={this.props.onInput}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                        onChange={this.handleChange}
                        disabled={this.props.disabled}
                    />

                    {
                        (this.props.sideAction ? (
                            <span className="field-side-action" onClick={this.props.onSideActionClick}>
                                {this.props.sideAction}
                            </span>
                        ) : null)
                    }

                    {
                        (this.props.passwordToggleable ? (
                            <span href="" className="toggle-password" onClick={this.togglePassword}>
                                <span className="hidden-state">{ t('show') }</span>

                                <span className="visible-state">{ t('hide') }</span>
                            </span>
                        ) : null)
                    }

                    {
                        (this.props.addon ? (
                            <span className={'field-input-addon' + (this.props.addonTransparent ? ' transparent' : '')} onClick={this.props.addonClick}>
                                {this.props.addon}
                            </span>
                        ) : null)
                    }

                </div>
            </div>
        );
    }
}

export default withTranslation('common')(FieldDefault);
